import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { FileRoleType } from '@/common/types/ApiResponseTypes.type';
import { ImagesListName } from '@/common/utils/ImagesListName';
import { getDamagedAdjusterAttachedImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedImages/getDamagedAdjusterAttachedImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const ShowInitialVisitAttachedVehicleImagesTab = ({
  userType,
}: {
  userType: FileRoleType;
}) => {
  const { id } = useParams();

  const { data: imagesData } = useQuery(
    getDamagedAdjusterAttachedImagesQueryOptions({
      id: Number(id),
      type: 'vehicle',
      fileType: userType,
    }),
  );
  return (
    <>
      <Typography textStyle="b1" color="purple-1" my="24px">
        تصاویر دور تا دور وسیله‌نقلیه
      </Typography>
      {imagesData?.vehicle?.length || imagesData?.damaged_parts?.length ? (
        <>
          {' '}
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.vehicle?.map((vehicleImages, index) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: ImagesListName({
                      titleType: 'attachment',
                      index,
                    }),
                    src: vehicleImages.image,
                  }}
                />
              );
            })}
          </Flex>
          {imagesData?.damaged_parts?.length ? (
            <>
              <Typography textStyle="b1" color="purple-1" my="24px">
                تصاویر نقاط آسیب‌دیده
              </Typography>
              <Flex
                gap="1rem"
                maxWidth="maxContainer"
                margin="auto"
                mt="1.5rem"
                className={grid({ columns: 2 })}
              >
                {imagesData?.damaged_parts?.map((vehicleImages) => {
                  return (
                    <ImageCard
                      key={vehicleImages.id}
                      imageData={{
                        name: vehicleImages.title?.fa_const,
                        src: vehicleImages.image,
                      }}
                    />
                  );
                })}
              </Flex>
            </>
          ) : null}
        </>
      ) : (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      )}
    </>
  );
};

export default ShowInitialVisitAttachedVehicleImagesTab;
